module.exports = __webpack_public_path__ + "img/tom.f6fd00cf.png";